import apiClient, { apiClientBlob } from "@/services/ApiClient";

export function importActions(path) {
  const getUploadingStatus = () => apiClient.get(`${path}/items/import/status`);
  const downloadImportExcelTemplate = () => apiClientBlob.get(`${path}/items/import/template`);
  //getImportPath for Dropzone Lib
  const getImportPath = () => `${path}/items/import`;

  return { getUploadingStatus, downloadImportExcelTemplate, getImportPath };
}
